import { post, get } from "@/utils/request";

// Init Captcha
export const initCaptcha = () => get(`/auth/resource/sliderCaptcha`, {});

// Verify Captcha
export const verifyCaptcha = (data: any) => post(`/auth/verify`, data);
